import { StateCreator } from "zustand";
import type { SkyViewStore } from "./index";

export interface SearchHighlightSlice {
  searchQuery: string | null;
  highlightedPageId: string | null;
  setSearchQuery: (query: string | null) => void;
  setHighlightedPageId: (pageId: string | null) => void;
  clearSearchHighlight: () => void;
}

export const createSearchHighlightSlice: StateCreator<
  SkyViewStore,
  [["zustand/persist", unknown], ["zustand/immer", never]],
  [],
  SearchHighlightSlice
> = (set) => ({
  searchQuery: null,
  highlightedPageId: null,
  setSearchQuery: (query: string | null) =>
    set(() => ({
      searchQuery: query,
    })),
  setHighlightedPageId: (pageId: string | null) =>
    set(() => ({
      highlightedPageId: pageId,
    })),
  clearSearchHighlight: () =>
    set(() => ({
      searchQuery: null,
      highlightedPageId: null,
    })),
});
